






import {Component, Vue} from 'vue-property-decorator';
import {g2plotRender} from '@antv/chart-advisor';

@Component
export default class AvaView extends Vue {


  mounted() {
    let container: HTMLElement = document.getElementById('mountNode')!;
    let data = [
      {
        'x': '家具家电',
        'y': 43
      },
      {
        'x': '粮油副食',
        'y': 535
      },
      {
        'x': '美容洗护',
        'y': 229
      },
      {
        'x': '母婴用品',
        'y': 602
      },
      {
        'x': '进口食品',
        'y': 671
      },
      {
        'x': '食品饮料',
        'y': 598
      },
      {
        'x': '家庭清洁',
        'y': 89
      }
    ];
    let config = {
      'title': {
        'visible': true,
        'text': '柱状图'
      },
      'description': {
        'visible': true,
        'text': '一个简单的柱状图'
      },
      'legend': {
        'flipPage': false
      },
      'xAxis': {
        'title': {
          'visible': false
        }
      },
      'yAxis': {
        'title': {
          'visible': false
        }
      },
      'forceFit': false,
      'width': 560,
      'height': 500,
      'xField': 'x',
      'yField': 'y',
      'color': [
        '#5B8FF9'
      ]
    };
    g2plotRender(container, data, {type: 'Column', configs: config});

  }


}
